import React, { useEffect, useRef } from "react";
import { useFormContext } from "react-hook-form";

function BasicInfo(props) {
  const { nextStep, prevStep } = props;
  const {
    register,
    watch,
    setValue,
    trigger,
    formState: { errors },
    getValues,
  } = useFormContext();

  return (
    <>
      <div className="w-full space-y-5">
        <div className="space-y-5">
          <div className="space-y-8 mt-4">
            <div>
              <label className="text-lg text-gray-500">Client Name *</label>
              <input
                type="text"
                name="client_name"
                placeholder="Write your name "
                className="outline-none border-b w-full py-2 text-sm"
                {...register("client_name", {
                  required: "Client name is required.",
                   validate: (v) =>
      v.trim() !== "" || "Please provide name.",  
                })}
              />
              {errors.client_name && (
                <p className="text-red-500 text-sm mt-1">
                  {errors.client_name.message}
                </p>
              )}
            </div>
            <div>
              <label className="text-lg text-gray-500">Email *</label>

              <input
                type="text"
                name="email"
                placeholder=" Write your email "
                className="outline-none border-b w-full py-2 text-sm"
                {...register("email", {
                  required: "Email is required.",
                  pattern: {
                    value: /\S+@\S+\.\S+/,
                    message: "Enter a valid email",
                  },
                })}
              />
              {errors.email && (
                <p className="text-red-500 text-sm mt-1">
                  {errors.email.message}
                </p>
              )}
            </div>

            <div>
              <label className="text-lg text-gray-500">Business Name *</label>

              <input
                type="text"
                name="business_name"
                placeholder="Write your business name  "
                className="outline-none border-b w-full py-2 text-sm"
                {...register("business_name", {
                  required: "Business name is required.",
                   validate: (v) =>
      v.trim() !== "" || "Business name is required.",  
                })}
              />
              {errors.business_name && (
                <p className="text-red-500 text-sm mt-1">
                  {errors.business_name.message}
                </p>
              )}
            </div>
            <div>
              <label className="text-lg text-gray-500">Industry *</label>

              <input
                type="text"
                name="industry"
                placeholder="Mention industry"
                className="outline-none border-b w-full py-2 text-sm"
                {...register("industry",{
                  required:"Please mention industry name.",
                   validate: (v) =>
      v.trim() !== "" || "Please mention industry name.", 
                })}
              />
              {errors.industry && (
                <p className="text-red-500 text-sm mt-1">
                  {errors.industry.message}
                </p>
              )}
            </div>
            <div>
              <label className="text-lg text-gray-500">Website URL</label>

              <input
                type="text"
                name="website_url"
                placeholder="Provide website URL"
                className="outline-none border-b w-full py-2 text-sm"
                {...register("website_url")}
              />
               
            </div>
            <div>
              <label className="text-lg text-gray-500">Target Audience</label>
              <div className="pt-2">
                <div className="flex items-center">
                  <label className="text-gray-500  space-x-1  cursor-pointer">
                    <input
                      type="radio"
                      {...register("target_audience")}
                      value="demographics"
                      className="accent-[#6D1349] cursor-pointer  focus:outline-none focus:ring-0"
                    />
                    <span className="text-gray-500">
                      Demographics (age, gender, location, income, etc.)
                    </span>
                  </label>
                </div>
                <div className="flex items-center">
                  <label className="space-x-1 cursor-pointer">
                    <input
                      type="radio"
                      {...register("target_audience")}
                      className="accent-[#6D1349] cursor-pointer"
                      value="interests"
                    />
                    <span className="text-gray-500">Interests</span>
                  </label>
                </div>
                <div className="flex items-center  ">
                  <label className="space-x-1 cursor-pointer">
                    <input
                      type="radio"
                      {...register("target_audience")}
                      className="accent-[#6D1349] cursor-pointer"
                      value="behaviors"
                    />
                    <span className="text-gray-500">Behaviors</span>
                  </label>
                </div>
              </div>
            </div>

            <textarea
              name="target_audience_description"
              rows={4}
              {...register("target_audience_description")}
              placeholder="Describe who are your target audience?"
              className="outline-none border-gray-200 outline-gray-300 w-full rounded-sm mt-4 text-gray-500"
            ></textarea>
          </div>
        </div>
        <div className="flex justify-between items-center">
          <button
            className=" bg-[#FFC067] font-bold  rounded px-6 py-3 text-base md:text-lg hover:bg-[#DF73FF]  transition ease-in duration-300 cursor-pointe text-dark "
            onClick={async () => {
              const isValid = await trigger([
                "client_name",
                "email",
                "business_name",
                "industry"
              ]);
              if (isValid) {
                nextStep();
            if (typeof window !== "undefined") {
        window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
      }
              }
            }}
          >
            Next
          </button>
        </div>
      </div>
    </>
  );
}

export default BasicInfo;
